import React, { ChangeEvent, Component, ReactNode } from 'react';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import CustomLoading from '../../../custom/CustomLoading';
import Icon from '../../../../icons/Icon';
import { RootState } from '../../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import DataType from '../../../../constant/DataType';
import { GroupBySegment, GroupSegmentField } from '../../../../domain/chart/editor/Segment';
import { SegmentItem } from '../../../../domain/chart/ChartDomains';
import { isArray } from 'lodash';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from 'components/custom/FormicaSearchSelectBox';
import FormicaInput from 'components/custom/FormicaInput';
import ChartValueFactory from '../../../../util/ChartValueFactory';
import { User } from '../../../../domain/rbac/RbacDomains';
import LanguageUtil from '../../../../util/LanguageUtil';

class SegmentGroupBy extends Component<Props> {
  render() {
    const { segmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (groupBySegment == null) return <CustomLoading />;
    return (
      <div className={'flex flex-col w-full h-full items-start justify-start gap-y-4'}>
        {groupBySegment.field && groupBySegment.field.length <= 0 ? this.getWhenGroupByFieldsIsEmpty() : this.getWhenGroupByFieldsIsNotEmpty()}
      </div>
    );
  }

  /*private getAvailableVariablesWithoutSelectedVariable = () => {
    const {chart: {chartEditorOptions}} = this.props;
    const fields = this.getAvailableElasticVariables();
    return fields?.filter((field) => {
      const selectedFields = chartEditorOptions?.segmentItem?.segments?.groupBy?.field;
      if (selectedFields != undefined) {
        return !selectedFields.map((f: any) => f.field).includes(field.value);
      }
      return true;
    })
  }*/

  private getAvailableElasticVariables = () => {
    const {
      chart: { chartEditorOptions },
      user,
    } = this.props;
    const elasticVariables = ChartValueFactory.initializeElasticVariablesForChartMetricAndSegment(user?.activeRiskType as string).filter(
      (field) => field.dataType == DataType.STRING || field.dataType == DataType.OBJECT,
    );
    if (chartEditorOptions.transactionVariables && isArray(chartEditorOptions?.transactionVariables)) {
      const transactionVariables = chartEditorOptions?.transactionVariables
        ?.filter((field) => field.dataType == DataType.STRING)
        ?.map((field) => {
          return {
            label: field.label,
            value: field.value,
            dataType: field.dataType,
          };
        });
      return [...elasticVariables, ...transactionVariables];
    }
    return [];
  };

  private setField = (field: GroupSegmentField, value: FormicaSelectBoxItem) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment: GroupBySegment | undefined = segmentItem?.segments.groupBy;
    if (segmentItem && groupBySegment != undefined) {
      groupBySegment.field.forEach((f: GroupSegmentField) => {
        if (f.field == field.field) {
          f.field.name = value.value;
          f.field.dataType = value.dataType as DataType;
        }
      });

      groupBySegment.appearance.name = `Group by ${value.label}`;
      segmentItem.name = `Group by ${value.label}`;
      onChangeSegmentItem(segmentItem);
    }
  };

  private setOrderBy = (order: 'asc' | 'desc') => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (segmentItem && groupBySegment != null) {
      groupBySegment.orderBy.order = order;
      onChangeSegmentItem(segmentItem);
    }
  };

  private removeField(field: GroupSegmentField) {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (segmentItem && groupBySegment != null) {
      groupBySegment.field = groupBySegment.field.filter((f: GroupSegmentField) => f.field != field.field);
      onChangeSegmentItem(segmentItem);
    }
  }

  private addField = () => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (segmentItem && groupBySegment != null) {
      const groupByField: GroupSegmentField = {
        field: {
          name: '',
          dataType: DataType.STRING,
        },
      };
      groupBySegment.field.push(groupByField);
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeField = (e: FormicaSelectBoxItem) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem?.segments?.groupBy : null;
    const appearance = segmentItem ? segmentItem?.segments?.groupBy?.appearance : null;
    if (segmentItem && groupBySegment != null) {
      const groupByField: GroupSegmentField = {
        field: {
          name: e.value,
          dataType: e.dataType as DataType,
        },
      };
      if (groupBySegment.field && groupByField.field.name.length <= 0) groupBySegment.field = [];
      groupBySegment.field.push(groupByField);
      segmentItem.name = `${e.label}`;
      if (appearance) appearance.name = segmentItem.name;

      onChangeSegmentItem(segmentItem);
    }
  };

  private getRankByOptions = () => {
    const {
      chart: { chartEditorOptions },
    } = this.props;
    const metricLabels = chartEditorOptions.metricItem.map((metricItem) => {
      return {
        label: metricItem.name,
        value: metricItem.name,
      };
    });
    return [{ label: 'alphabetical', value: 'alphabetical' }, ...metricLabels];
  };

  private onChangeNumberOfValues = (e: ChangeEvent<HTMLInputElement>) => {
    const { onChangeSegmentItem, segmentItem } = this.props;
    const groupBySegment = segmentItem?.segments.groupBy;
    if (groupBySegment != undefined) {
      groupBySegment.size = e.currentTarget.value as unknown as number;
      onChangeSegmentItem(segmentItem!);
    }
  };

  private onChangeGroupOtherValues = (e: ChangeEvent<HTMLInputElement>) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const groupBySegment: GroupBySegment | undefined = segmentItem?.segments?.groupBy;
    if (groupBySegment != undefined) {
      groupBySegment.groupOthers = e.currentTarget.checked;
      onChangeSegmentItem(segmentItem!);
    }
  };

  private onChangeRankBy = (e: FormicaSelectBoxItem) => {
    const {
      segmentItem,
      onChangeSegmentItem,
      chart: { chartEditorOptions },
    } = this.props;
    const groupBySegment: GroupBySegment | undefined = segmentItem?.segments?.groupBy;
    if (groupBySegment != undefined) {
      const metricItem = chartEditorOptions.metricItem.find((c) => c.metric.appearance.name == e.value);
      groupBySegment.orderBy.type = e.value == 'alphabetical' ? 'alphabetical' : 'metric';
      groupBySegment.orderBy.field = {
        name: e.value,
        dataType: this.getAvailableElasticVariables().find((f) => f.value == e.value)?.dataType || DataType.STRING,
      };
      groupBySegment.orderBy.metricFunction = metricItem?.metric.type || 'Count';
      groupBySegment.orderBy.metricField = metricItem?.metric.field.name || '';

      onChangeSegmentItem(segmentItem!);
    }
  };

  private getWhenGroupByFieldsIsNotEmpty = () => {
    const { segmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (groupBySegment == null) return <CustomLoading />;
    return (
      <div className={'flex flex-col w-full h-full gap-y-4 items-center'}>
        {this.getFields()}
        <div className={'flex w-full items-center'}>
          <a onClick={() => this.addField()} className={'px-2 py-2 bg-white border-[1px] border-f-purple text-f-purple w-full rounded cursor-pointer'}>
            {' '}
            + Add Field
          </a>
        </div>
        <div className={'flex w-full  flex-col'}>
          <label className={'text-sm text-f-black-3'} htmlFor={'number-of-values'}>
            Number of Values
          </label>
          <FormicaInput
            value={groupBySegment.size}
            type={'number'}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              this.onChangeNumberOfValues(e);
            }}
            id={'number-of-values'}
          />
        </div>
        <div className={'flex w-full flex-col'}>
          <label className={'text-sm text-f-black-3'} htmlFor={'rank-by'}>
            Rank By
          </label>
          <FormicaSearchSelectBox
            value={groupBySegment.orderBy.field.name}
            options={this.getRankByOptions()}
            placeholder={groupBySegment.orderBy.field.name}
            rounded={false}
            customSize={'medium'}
            onChange={(e: FormicaSelectBoxItem) => this.onChangeRankBy(e)}
            id={'rank-by'}
          />
        </div>
        <div className={'flex flex-col w-full items-start justify-center'}>
          <label className={'text-sm text-f-black-3'}>Rank Direction</label>
          <div className={'flex w-full bg-[#F7F8FA] h-[40px] rounded px-1.5 py-1'}>
            <div
              onClick={() => this.setOrderBy('asc')}
              className={`text-f-black-3 gap-x-2 cursor-pointer  w-full flex items-center justify-center rounded px-1 
                            ${groupBySegment.orderBy.order == 'asc' ? 'bg-white text-primary' : ''}`}
            >
              <Icon icon={'arrow-up'} size={16} />
              Ascending
            </div>
            <div
              onClick={() => this.setOrderBy('desc')}
              className={`text-f-black-3 gap-x-2 cursor-pointer w-full flex items-center justify-center rounded px-1
                             ${groupBySegment.orderBy.order == 'desc' ? 'bg-white text-primary' : ''}`}
            >
              <Icon icon={'arrow-down'} size={16} />
              Descending
            </div>
          </div>
        </div>
        {/*<div className={"flex w-full items-center justify-start gap-x-2 text-xs text-f-purple"}>
          <FormicaToggleSwitch value={groupBySegment.groupOthers}
                               onChange={(e) => this.onChangeGroupOtherValues(e)}/>
          <p>Group other values as “Other” </p>
        </div>*/}
      </div>
    );
  };

  private getWhenGroupByFieldsIsEmpty = () => {
    const { segmentItem } = this.props;
    const groupBySegment = segmentItem ? segmentItem.segments.groupBy : null;
    if (groupBySegment == null) return <CustomLoading />;
    return (
      <div className={'flex flex-col w-full h-full'}>
        <label htmlFor={'group-by-field'} className={'text-primary text-sm text-f-black-3'}>
          Field
        </label>
        <FormicaSearchSelectBox
          value={groupBySegment.field.length > 0 ? groupBySegment.field[0].field.name : ''}
          onChange={(e: FormicaSelectBoxItem) => this.onChangeField(e)}
          placeholder={LanguageUtil.get({ id: 'common.input.placeholder.selectField', defaultMessage: 'Select a field' })}
          rounded={false}
          customSize={'medium'}
          options={this.getAvailableElasticVariables()}
        />
      </div>
    );
  };

  private getFields = (): ReactNode => {
    const { segmentItem } = this.props;
    const fields: GroupSegmentField[] | undefined = segmentItem?.segments?.groupBy?.field;
    if (fields != undefined && fields.length > 0) {
      return fields.map((field: GroupSegmentField, index) => {
        return (
          <div key={index} className={'w-full h-[34px]  flex items-center justify-between'}>
            <FormicaSearchSelectBox
              selectBoxClassName={'w-full'}
              value={field.field.name}
              placeholder={field.field.name}
              rounded={false}
              customSize={'medium'}
              onChange={(e: FormicaSelectBoxItem) => this.setField(field, e)}
              options={this.getAvailableElasticVariables()}
              id={'group-by-field'}
            />
            <div
              onClick={() => this.removeField(field)}
              className={'cursor-pointer h-full flex items-center justfiy-center px-1 border-r border-t border-b border-f-black-5'}
            >
              <Icon icon={'close'} size={16} className={'ml-2 cursor-pointer'} />
            </div>
          </div>
        );
      });
    }
  };
}

interface Props extends ReduxProps {
  segmentItem: SegmentItem | null;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
  user: state.auth.user as User,
});

const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(SegmentGroupBy);
